import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-add-test-modal',
  templateUrl: './add-test-modal.component.html',
  styleUrls: ['./add-test-modal.component.scss']
})
export class AddTestModalComponent implements OnInit {

  @Input() associate_name;
  @Input() associate_id;
  @Input() branch_id;
  @Input() pincode;
  @Input() order_id;
  @Input() line_items;
  @Input() business_id;
  @Input() channel_code;
  @Input() org_code;
  @Input() tenant_code ;
  testNameRequest = {};
  testNameRes = {};
  addTestForm: FormGroup;
  addTestNameRequest = {};
  testNameList = [];
  itemNameWithPriceList: any[] = [];
  enterTestName: string;
  lastkeydown1: number = 0;
  tempTestNameList = [];
  selectedItemCode: string;
  grossAmount: Number;
  netAmount: Number;
  discountAmount: Number;
  itemId: string;
  msg:string ="";
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  constructor(public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinnerService: NgxSpinnerService
  ) {
    this.addTestForm = new FormGroup({
      diagnosticscentrename: new FormControl(),
      testname: new FormControl(),
      price: new FormControl(),
      associatecode: new FormControl(),


    });

  }

  ngOnInit(): void {
   // this.SpinnerService.show();

    this.addTestForm.setValue({ 'diagnosticscentrename': this.associate_name, 'testname': '', 'price': '', 'associatecode': this.associate_id });
   // this.getTestNameData();

  }

  getTestNames($event) {
    let testName = (<HTMLInputElement>document.getElementById('testId')).value;
    this.testNameList = [];
    //console.log("method called");
    if (testName.length > 3) {


      if ($event.timeStamp - this.lastkeydown1 > 200) {
        this.getTestNameData();
      }
    }
  }




  getTestNameData() {
    this.testNameList = [];
    this.testNameRequest["method"] = "fetchservice/getAllAssociateServices";
    this.testNameRequest["type"] = "post";
   // this.testNameRequest["businessID"] = this.constantsService.BUSINESS_ID;
   // this.testNameRequest["businessID"] = "4";
    this.testNameRequest["businessID"] = this.business_id;
    this.testNameRequest["searchString"] = "";
    if (this.addTestForm.get("testname").value != "" && this.addTestForm.get("testname").value != undefined)
      this.testNameRequest["searchString"] = this.addTestForm.get("testname").value;
    //this.testNameRequest["searchString"] = "";
    this.testNameRequest["zipcode"] = this.pincode;
    // this.testNameRequest["zipcode"] ="5426";
    this.testNameRequest["itemType"] = "Test";
    this.testNameRequest["associateCode"] = this.addTestForm.get("associatecode").value;
    //this.testNameRequest["associateCode"] = "DC00000000001296";
    this.testNameRequest["branchId"] = this.branch_id;
    // this.testNameRequest["branchId"] = "5426";
    this.testNameRequest["getPrice"] = true;
    this.testNameRequest["engage_at"] = "1";
   // this.testNameRequest["method"] = "fetchservice/getAllAssociateServices";
    //this.testNameRequest["type"] = "post";
    
    this.testNameRequest["tenantCode"] = this.tenant_code;
    this.testNameRequest["orgCode"] = this.org_code;
    this.omsServiceService.getTestNameDetails(this.testNameRequest).subscribe(

      (res) => {
        this.testNameRes = res;

        for (var i = 0; i < res["data"].length; i++) {
          this.testNameList.push({ "name": res["data"][i].vendorInfo.service_item_name });

          this.itemNameWithPriceList.push({
            "itemCode": res["data"][i].vendorInfo.service_item_code, "itemName": res["data"][i].vendorInfo.service_item_name, "price": res["data"][i].vendorInfo.netAmount, "grossAmount": res["data"][i].vendorInfo.grossAmount, "netAmount": res["data"][i].vendorInfo.netAmount, "discountAmount": res["data"][i].vendorInfo.discountAmount

          });

        }
        //console.log(this.testNameList);
        this.spinnerService.hide();
      }
    )
  }

  addTestNameData(data) {
    this.msg= "";
   this.spinnerService.show();
    let lineItemRequest = {};
    let lineItemBusinessData = {};
    let lineItemBusinessDataArray = {};

    //lineItemBusinessData["business"]=this.constantsService.BUSINESS_ID;
    lineItemBusinessData["business"]="4";
    //  lineItemBusinessData["itemcodes"] = ["TS1801CAHSRPT0118"];
    lineItemBusinessData["itemcodes"] = [this.selectedItemCode];
    lineItemBusinessDataArray["data"] = [lineItemBusinessData];

    
    lineItemBusinessDataArray = { 
      "method": "fetchservice/getLineItemsByServiceCodes",
      "type": "POST" ,
     ...lineItemBusinessDataArray
    };

    
    lineItemRequest = lineItemBusinessDataArray;


    this.omsServiceService.getLineItemDetails(lineItemRequest).subscribe(
      (res) => {
       // if (res["status"] == "SUCCESS") { 
          
            for (let key in res) {
                if(!res[key]) {
                  //console.log(key + ' is not found in MDM')
                  this.isFailureMsg =true;
                  this.msg=  key + ' is not found in MDM'
                  this.spinnerService.hide();
  
                } 

              let serviceItemDetails = res[key];
              this.itemId = key;
              //this.itemId = serviceItemDetails["serviceCode"];
            } 

          this.addTestNameRequest["method"] = "OMS/api/operation.php/v1/order/lineitem/crud/multi";
          this.addTestNameRequest["type"] = "post";
          this.addTestNameRequest["order_id"] = this.order_id;

          this.addTestNameRequest["actionById"] = window.localStorage.getItem('actionById');
          this.addTestNameRequest["actionByName"] = window.localStorage.getItem('actionByName');
          //this.addTestNameRequest["source"] = "1",
          this.addTestNameRequest["source"] = "CCO",
            this.addTestNameRequest["channelCode"] = this.constantsService.CHANNEL_CODE;

            //this.addTestNameRequest["channelCode"] = this.channel_code;
          // this.addTestNameRequest["lineitem"] = [this.testNameRes["data"][0].vendorInfo.service_item_code];
          //TS1500FACRIXR0292
          this.addTestNameRequest["lineitem"] = [this.selectedItemCode];
          // this.addTestNameRequest["lineitem"] ="TS1500DGHDPAE0003";
          this.addTestNameRequest["action"] = this.constantsService.ACTION;
          //this.itemId ="";
          // this.getLineItemDetails(this.selectedItemCode);

          this.addTestNameRequest["items"] = [
            {
              "itemid": this.itemId,
              "itemname": data.controls.testname.value,
              "line_item": this.selectedItemCode,
              "quantity": "1",
              "gross_amount": this.grossAmount,
              "discount_amount": this.discountAmount,
              "net_amount": this.netAmount,
              "service_type": this.business_id,
              "reportdeliverydatefrom": "2020-06-20T22:47:52.399Z",
              "reportdeliverydateto": "2020-06-20T22:47:52.399Z",
              "sampletype": 0,
              "department": "Medicine",
              "type": "post",
              "action": "OMS/api/operation.php/v1/order/lineitem/crud/multi"
            }
          ];

          this.omsServiceService.addItem(this.addTestNameRequest).subscribe(

            (res) => {
              //console.log(res);
              if(res["status"]==1)
              {
                this.isSuccessMsg =true;
               
                this.msg=res["message"];
              }else{
                this.isFailureMsg =true;
                this.msg=res["message"];
              }
              this.spinnerService.hide();
                //alert(res["message"]);
                
              //this.modal.close();
              //   this._router.navigate(["order-details", this.order_id]);
            }

          )

       // }

      });


  }
  getTestNameValues($event) {
    let testName = (<HTMLInputElement>document.getElementById('testNameId')).value;

    if (testName.length > 4) {
      if ($event.timeStamp - this.lastkeydown1 > 200) {


        this.getTestNameData();
      }
    }
  }

  getPrice() {
    this.selectedItemCode = "";
    this.grossAmount = 0;
    this.netAmount = 0;
    this.discountAmount = 0;
    this.enterTestName = this.addTestForm.get("testname").value;
    //console.log(this.enterTestName);
    if (this.enterTestName != "" && this.enterTestName != undefined) {

      for (let i = 0; i < this.itemNameWithPriceList.length; i++) {
        if (this.enterTestName == this.itemNameWithPriceList[i].itemName) {
          //console.log("service item Code =" + this.itemNameWithPriceList[i].itemCode);
          this.selectedItemCode = this.itemNameWithPriceList[i].itemCode;
          this.discountAmount = this.itemNameWithPriceList[i].grossAmount;
          this.netAmount = this.itemNameWithPriceList[i].netAmount;
          this.discountAmount = this.itemNameWithPriceList[i].discountAmount;
          this.addTestForm.setValue({ 'diagnosticscentrename': this.associate_name, 'testname': this.enterTestName, 'price': this.itemNameWithPriceList[i].price, 'associatecode': this.associate_id })
        }
      }

    }

  }

  getLineItemDetails(lineItem) {
    let lineItemRequest = {};
    let lineItemBusinessData = {};
    let lineItemBusinessDataArray = {};

    //lineItemBusinessData["business"] = this.constantsService.BUSINESS_ID;
    lineItemBusinessData["business"] = this.business_id;
    // lineItemBusinessData["itemcodes"] = ["TS1801CAHSRPT0118"];
    lineItemBusinessData["itemcodes"] = [lineItem];
    lineItemBusinessDataArray["data"] = [lineItemBusinessData];

    lineItemBusinessDataArray = { 
      "method": "fetchservice/getLineItemsByServiceCodes",
      "type": "POST" ,
     ...lineItemBusinessDataArray
    };

    lineItemRequest = lineItemBusinessDataArray;


    this.omsServiceService.getLineItemDetails(lineItemRequest).subscribe(
      (res) => {

        for (let key in res) {
          if(!res[key]) {
            //console.log(key + ' is not found in MDM')
            this.isFailureMsg =true;
            this.msg=  key + ' is not found in MDM'
            this.spinnerService.hide();

          } 

        let serviceItemDetails = res[key];
        this.itemId = key;
        //this.itemId = serviceItemDetails["serviceCode"];
      }

        //MDM V4 api response handler start
        // if (res["status"] == "SUCCESS") {
        //   //console.log(res); 
        //   for (let obj of res["dataObject"]) {
        //     for (let key in obj) {
        //       //console.log("      key:", key);
        //       let serviceItemDetails = obj[key];

        //       this.itemId = serviceItemDetails["testId"];

        //     }
        //   }
        // }
        //MDM V4 api response handler end

      });

  }

  modelClose()
  {

    this.modal.close();
    
  }
}
